import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import blogPosts from "../data/blogPosts";

const BlogPostPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post || !post.published || !post.component) {
    return (
      <div className="legal-page" style={{ textAlign: "center" }}>
        <div className="article-container">
          <h1>Post Not Found</h1>
          <p style={{ color: "var(--text-secondary)", margin: "20px 0 32px" }}>
            This blog post doesn't exist or hasn't been published yet.
          </p>
          <Link to="/blog" className="btn btn-primary">
            Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  const PostContent = post.component;

  const handleConsultationClick = () => {
    navigate("/", { state: { scrollTo: "contact" } });
  };

  return (
    <article
      className="blog-article"
      aria-label={`Blog post: ${post.title}`}
      style={{ paddingTop: "140px" }}
    >
      <div className="article-container">
        <div style={{ marginBottom: "32px" }}>
          <Link
            to="/blog"
            style={{
              fontSize: "0.85rem",
              color: "var(--text-muted)",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            &larr; All Posts
          </Link>
        </div>

        <header className="article-header">
          <span className="blog-tag">{post.tag}</span>
          <h1>{post.title}</h1>
          <div className="article-author">
            <img
              src="/patrick-zanowski.png"
              alt="Patrick Zanowski"
              className="author-avatar"
              width="44"
              height="44"
              loading="eager"
            />
            <div className="author-info">
              <a
                href="https://www.linkedin.com/in/patrickzanowski"
                target="_blank"
                rel="noopener noreferrer"
                className="author-name"
              >
                Patrick Zanowski
              </a>
              <div className="article-meta">
                <span>{post.date}</span>
                {post.readTime && <span>{post.readTime}</span>}
              </div>
            </div>
          </div>
        </header>

        <PostContent />

        <div className="article-cta">
          <p>
            <strong>Ready to build your next AI-powered product?</strong>
          </p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConsultationClick}
          >
            Book a Technical Consultation
          </button>
        </div>
      </div>
    </article>
  );
};

export default BlogPostPage;
